<template>
    <b-card>
        <b-modal id="create-or-update" :title="modalTitle" no-close-on-esc no-close-on-backdrop>
            <job-exit-special-cause-create-or-update v-model="specialCause"></job-exit-special-cause-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <b-overlay :show="causeLoading" opacity="0.2">
            <button class="btn btn-primary mb-1" v-on:click="createNew(false)">Ana Sebep Oluştur</button>
            <div v-for="(item,index) in causes" :key="index" :class="index != 0 ? 'mt-1' : null">
                <div class="alert alert-dark mb-0">
                    <div class="alert-body pl-75 pr-50 py-50">
                        <div class="row align-items-center">
                            <div class="col">
                                <span>{{item.Name}}</span>
                            </div>
                            <div class="col-auto">
                                <div class="d-flex">
                                    <button v-b-tooltip.noninteractive.hover.bottom title="Alt Sebebi Ekle" v-on:click="createNew(item)" class="btn btn-sm rounded-circle btn-icon btn-primary mr-50">
                                        <feather-icon icon="PlusIcon"></feather-icon>
                                    </button>
                                    <button v-b-tooltip.noninteractive.hover.bottom title="Ana Sebebi Düzenle" v-on:click="edit(item,false)" class="btn btn-sm rounded-circle btn-icon btn-flat-secondary mr-50">
                                        <feather-icon icon="Edit2Icon"></feather-icon>
                                    </button>
                                    <button v-b-tooltip.noninteractive.hover.bottom title="Ana Sebebi Sil" v-on:click="del(item,false)" class="btn btn-sm rounded-circle btn-icon btn-flat-danger">
                                        <feather-icon icon="TrashIcon"></feather-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <template v-if="(item.SubJobExitSpecialCauseResponses || []).length">
                    <v-tree-view ref="treeViews" v-model="item.SubJobExitSpecialCauseResponses" :errors="errors">
                        <template #data="{data}">
                            <div class="row align-items-center pl-25">
                                <div class="col">
                                    <span>{{data.Name}}</span>
                                </div>
                                <div class="col-auto text-right">
                                    <button v-b-tooltip.noninteractive.hover.bottom title="Alt Sebebi Düzenle" v-on:click="edit(data,true)" class="btn btn-sm btn-icon btn-flat-secondary ml-25 mr-25">
                                        <feather-icon icon="Edit2Icon"></feather-icon>
                                    </button>
                                    <button v-b-tooltip.noninteractive.hover.bottom title="Alt Sebebi Sil" v-on:click="del(data,true)" class="btn btn-sm btn-icon btn-flat-danger ml-25">
                                        <feather-icon icon="TrashIcon"></feather-icon>
                                    </button>
                                </div>
                            </div>
                        </template>
                    </v-tree-view>
                </template>
                <template v-else>
                    <div class="text-center pt-1 px-1">Bu ana sebep için herhangi bir alt sebep bulunmamaktadır.</div>
                </template>
            </div>
            <div v-if="(causes || []).length == 0 && !causeLoading" class="text-center p-1">
                Henüz bir sebep kaydı bulunmaktadır.
            </div>
        </b-overlay>

    </b-card>
</template>

<script>
import { BCard, BOverlay,VBTooltip } from 'bootstrap-vue'
import VTreeView from '@/components/v-tree-view/VTreeView'
import JobExitSpecialCauseCreateOrUpdate from './components/JobExitSpecialCauseCreateOrUpdate.vue'
import HumanResourcesParameterApi from '@/api/human-resources-parameters';

export default {
    components:{
        BCard,
        BOverlay,
        VTreeView,
        JobExitSpecialCauseCreateOrUpdate
    },
    directives:{
        "b-tooltip":VBTooltip
    },
    data(){
        return{
            editing:false,
            errors:{},
            loading:false,
            causeLoading:false,
            causes:[],
            modalTitle:"Oluştur",
            specialCause:{
                Id:null,
                Name: null,
                ParentJobExitSpecialCauseId:null,
                ParentJobExitSpecialCauseName:null,
                SGKParameterIds:[]
            }
        }
    },
    mounted(){
        this.getCauses()
    },
    methods:{
        clearForm(){
            this.editing = false
            this.specialCause.Id = null
            this.specialCause.Name = null
            this.specialCause.ParentJobExitSpecialCauseId = null
            this.specialCause.ParentJobExitSpecialCauseName = null
            this.specialCause.SGKParameterIds = []
            this.modalTitle = "Oluştur"
        },
        createNew(item){
            this.clearForm()
            if(item){
                this.specialCause.ParentJobExitSpecialCauseId = item.Id
                this.specialCause.ParentJobExitSpecialCauseName = item.Name
                this.modalTitle = ["Alt Sebep Oluştur",item.Name].join(' | ')
            }
            this.$showModal('create-or-update')
        },
        getCauses(){
            this.causeLoading = true
            HumanResourcesParameterApi.JobExitSpecialCause.TreeList().then(res=>{
                this.causeLoading = false
                this.causes = res.data.Data
            }).catch(err=>{
                this.causeLoading = false
            })
        },
        createOrUpdate(){
            this.loading = true
            HumanResourcesParameterApi.JobExitSpecialCause.CreateOrUpdate(this.editing,this.specialCause).then(res=>{
                this.loading = false
                this.$result(res)
                if(res.data.Success){
                    this.getCauses()
                    this.$hideModal('create-or-update')
                }
            }).catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        edit(item,sub){
            this.clearForm()
            this.editing = true
            this.specialCause.Id = item.Id
            this.specialCause.Name = item.Name
            this.specialCause.ParentJobExitSpecialCauseId = item.ParentJobExitSpecialCauseId
            this.specialCause.ParentJobExitSpecialCauseName = item.ParentJobExitSpecialCauseName
            this.specialCause.SGKParameterIds = item.SGKParameterIds || []
            this.modalTitle = sub ? ["Alt Sebep Güncelle",item.Name].join(' | ') : "Ana Sebep Güncelle"
            this.$showModal('create-or-update')
        },
        del(item,sub){
            const text = sub ? `Bu işlem ${item.Name} isimli alt sebebi silecektir ve geri alınamaz.` : `Bu işlem ${item.Name} isimli ana sebebi ve alt sebeplerini silecektir ve geri alınamaz.`
            this.$confirm('Silmek istediğinize emin misiniz?',text).then(result=>{
                if(result){
                    HumanResourcesParameterApi.JobExitSpecialCause.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.getCauses()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>